<template>
  <UnstyledCta class="CtaLink" v-bind="{ action, text }" @click="$attrs.onClick">
    {{ text }}
    <span class="icon" v-html="arrowRightSvg" />
  </UnstyledCta>
</template>

<script>
import arrowRightSvg from '~/assets/ui/link-arrow-right.svg?raw'
import colors from './colors.json'
import UnstyledCta from './UnstyledCta.vue'

export default {
  components: {
    UnstyledCta,
  },
  props: {
    text: String,
    action: String,
  },
  data() {
    return {
      arrowRightSvg,
      colors,
    }
  },
}
</script>

<style scoped>
.CtaLink {
  display: inline-block;
  font-weight: 400;
  font-size: var(--link-font-size, var(--font-size-3));
  line-height: 1.3;
  color: v-bind('colors.brandColor');
  transition: color 0.15s;
}

.CtaLink:hover {
  color: v-bind('colors.brandColorDarker');
}

.CtaLink:focus {
  color: v-bind('colors.darkBlue');
}

.CtaLink[disabled] {
  color: v-bind('colors.darkGray');
}

.icon {
  display: inline-block;
  margin-left: 0.33em;
  position: relative;
  left: 0;
  transition: left 0.15s;
}

.CtaLink:hover .icon {
  left: 3px;
}
</style>
